var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"emd-nav-list__item",class:[
        {'_active': _vm.active},
        `_color_${_vm.color}`
      ]},[(!_vm.hasContentSlot)?_c('a',{staticClass:"emd-nav-list__link",attrs:{"data-testid":"list-item-anchor","href":_vm.href}},[_vm._t("default")],2):_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }